import { render, staticRenderFns } from "./Controlinetpays.vue?vue&type=template&id=871afdf2&scoped=true&"
import script from "./Controlinetpays.vue?vue&type=script&lang=js&"
export * from "./Controlinetpays.vue?vue&type=script&lang=js&"
import style0 from "./Controlinetpays.vue?vue&type=style&index=0&id=871afdf2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "871afdf2",
  null
  
)

export default component.exports